/**
 * API Configuration Utility
 * Handles dynamic API URL configuration based on environment
 */

// Get the base API URL based on environment
export const getApiBaseUrl = () => {
  // Check if we're in development (localhost)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8000/extraction';
  }
  
  // Production environment
  return process.env.REACT_APP_API_URL || 'https://video-scene-extractor-production.up.railway.app/extraction';
};

// Get the current environment
export const getEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT || 
         (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'development' : 'production');
};

// API endpoints
export const API_ENDPOINTS = {
  UPLOAD: '/upload/',
  STATUS: (sessionId) => `/status/${sessionId}/`,
  DOWNLOAD: (sessionId) => `/download_scenes/${sessionId}/`,
  USAGE: () => '/usage/',
  // Video Merge endpoints
  MERGE_UPLOAD: '/merge/upload/',
  MERGE_STATUS: (sessionId) => `/merge/status/${sessionId}/`,
  MERGE_DOWNLOAD: (sessionId) => `/merge/download/${sessionId}/`,
  MERGE_CANCEL: (sessionId) => `/merge/cancel/${sessionId}/`,
};

// Helper function to build full URLs
export const buildApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${endpoint}`;
};

// Configuration object
export const config = {
  apiBaseUrl: getApiBaseUrl(),
  environment: getEnvironment(),
  isDevelopment: getEnvironment() === 'development',
  isProduction: getEnvironment() === 'production',
};
